import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../app/freightconfirmation/app.sharemodule';
import { LayoutModule } from '../../../app/theme/layouts/layout.module';
import { RouterModule, Routes } from '@angular/router';
import { OnflyDriverComponent } from './onfly-driver.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        LayoutModule,
        RouterModule
    ],
    declarations: [
        OnflyDriverComponent
    ],
    exports: [
        OnflyDriverComponent
    ]
})
export class OnflyDriverModule { }

export { OnflyDriverComponent };
